import { Typography, Box, FormLabel } from "@mui/material";
import React from "react";

type UserProfileItemProps = {
  text: string;
  value: string;
};

const UserProfileItem: React.FC<UserProfileItemProps> = ({ text, value }) => {
  return (
    <Box>
      <FormLabel>{text}: </FormLabel>
      <Typography>{value}</Typography>
    </Box>
  );
};

export default UserProfileItem;
